/**
 * The right-click menu on the empty canvas.
 *
 * Both parts were declared inside FoldersTable's render, so every render
 * produced new component types and remounted the open menu — the same class of
 * bug as VisibilityBadge. `onSelect` closes the menu after the action, which is
 * what the inline version did by closing over its setter.
 */

import { cn } from '@/lib/utils';

export function CanvasMenuItem({ children, onClick, onSelect, disabled, className }) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={(event) => {
        onClick?.(event);
        onSelect?.();
      }}
      className={cn(
        'flex w-full items-center rounded-[4px] px-2.5 py-2 text-sm text-foreground',
        'hover:bg-muted disabled:opacity-50 disabled:pointer-events-none',
        className,
      )}
    >
      {children}
    </button>
  );
}

export function CanvasMenuSeparator() {
  return <div className="my-1 h-px bg-border" />;
}
